// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__yWpCE","text-layer":"card_text-layer__HO5H1","text-content":"card_text-content__Zz9aj"};